module.exports = __webpack_public_path__ + "img/buenos_aires_almagro.49b667ff.jpg";